import DoAPICall from "./DoAPICall";

// Create promotionentry ('C' in CRUD)
export async function createPromotionEntry(userToken, promotionentry) {
  const apiPayload = {
    httpMethod: "post",
    userToken,
    uri: "promotionentries",
    payLoad: {
      promotion_id: promotionentry.promotion_id,
      entryDate: promotionentry.entryDate,
      customerAccount: promotionentry.customerAccount,
      consumerType: promotionentry.consumerType,
      mobileNumber: promotionentry.mobileNumber,
      paymentAmount: promotionentry.paymentAmount,
      receiptNumber: promotionentry.receiptNumber,
      rewardAmount: promotionentry.rewardAmount,
      rewardRate: promotionentry.rewardRate,
      message: promotionentry.message,
      status: promotionentry.status,
      smsDelivered: promotionentry.smsDelivered
    },
    requestOptions: {},
  };
  return await DoAPICall(apiPayload);
}

// Get All promotionentries ('R' in CRUD)
export async function getPromotionEntries(userToken) {
  const apiPayload = {
    httpMethod: "get",
    userToken,
    uri: "promotionentries",
    payLoad: {},
    requestOptions: {},
  };
  return await DoAPICall(apiPayload);
}

// Get All promotionentries ('R' in CRUD)
export async function getEntriesOfPromotion(userToken,promotion_id) {
  const apiPayload = {
    httpMethod: "get",
    userToken,
    uri: "entriesofpromotion/" + promotion_id,
    payLoad: {},
    requestOptions: {},
  };
  return await DoAPICall(apiPayload);
}

// Get All UNREDEEMED promotionentries
export async function getPromotionEntriesNotRedeemed(userToken) {
  const apiPayload = {
    httpMethod: "get",
    userToken,
    uri: "promotionentries/notredeemed",
    payLoad: {},
    requestOptions: {},
  };
  return await DoAPICall(apiPayload);
}

export async function deliverPromotionEntrySMS(userToken,urlPrefix, id){
  const apiPayload = {
     httpMethod:'put',
     userToken,
     uri:'promotionentriessms/'+id,
     payLoad:{
        urlPrefix
     },
     requestOptions:{}
  }
  return await DoAPICall(apiPayload)
}

// Get All UNREDEEMED promotionentries
export async function getPromotionEntriesRedeemed(userToken) {
  const apiPayload = {
    httpMethod: "get",
    userToken,
    uri: "promotionentries/redeemed",
    payLoad: {},
    requestOptions: {},
  };
  return await DoAPICall(apiPayload);
}

// Get one promotionentry by ID ('R' in CRUD)
export async function getPromotionEntry(userToken, id) {
  const apiPayload = {
    httpMethod: "get",
    userToken,
    uri: "promotionentries/" + id,
    payLoad: {},
    requestOptions: {},
  };
  return await DoAPICall(apiPayload);
}

// Update promotionentry ('U' in CRUD)
export async function updatePromotionEntry(userToken, promotionentry) {
  const apiPayload = {
    httpMethod: "put",
    userToken,
    uri: "promotionentries/" + promotionentry.id,
    payLoad: {
      promotion_id: promotionentry.promotion_id,
      entryDate: promotionentry.entryDate,
      customerAccount: promotionentry.customerAccount,
      consumerType: promotionentry.consumerType,
      mobileNumber: promotionentry.mobileNumber,
      paymentAmount: promotionentry.paymentAmount,
      receiptNumber: promotionentry.receiptNumber,
      rewardAmount: promotionentry.rewardAmount,
      rewardRate: promotionentry.rewardRate,
      message: promotionentry.message,
      status: promotionentry.status,
      smsDelivered: promotionentry.smsDelivered
    },
    requestOptions: {},
  };
  return await DoAPICall(apiPayload);
}

// Delete promotionentry ('D' in CRUD)
export async function deletePromotionEntry(userToken, id) {
  const apiPayload = {
    httpMethod: "delete",
    userToken,
    uri: "promotionentries/" + id,
    payLoad: {},
    requestOptions: {},
  };
  return await DoAPICall(apiPayload);
}
